module.exports = __webpack_public_path__ + "img/MATILDE_CRUZ_2.c179c56d.jpeg";